import React from "react";
import "./spinner.css";

export const Spinner = () => {
  return (
    <div className="lds-facebook">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};
